module.exports = __webpack_public_path__ + "static/media/QS.f10c6b5a.svg";